// @ts-nocheck

(function () {
  function initTechCarousel(root) {
    const viewport = root.querySelector('.embla__viewport');
    if (!viewport || !window.EmblaCarousel) return;

    const embla = EmblaCarousel(viewport, { align: 'center', loop: true });

    const setActive = () => {
      const selected = embla.selectedScrollSnap();
      embla.slideNodes().forEach((slide) => {
        slide.classList.toggle('tech-carousel-slide--active', Number(slide.dataset.slideIndex) === selected);
      });
    };

    embla.on('select', setActive);
    embla.on('reInit', setActive);
    setActive();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-tech-carousel]').forEach(initTechCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
